/// model dung chung cho cac danh muc dong nhat chinh sua sau 28/8/2020
/// muc dich chung kieu khai bao cho nhanh
export class CategoryModel {
    id : number;
    code : string;
    name : string;
}